<template>
    <v-container fill-height class="align-start">
        <div class="row no-gutters" width="100%">
            <v-col>
                <v-toolbar class="elevation-0 mt-n3 row-full" height="relative">
                    <div class="container d-flex pb-3 pt-2 align-center">
                        <v-icon @click="$router.back()" class="go-back">mdi-arrow-left-bold</v-icon>
                        <v-toolbar-title color="primary" class="headline ml-5 font-weight-bold text-capitalize">Checkout</v-toolbar-title>
                    </div>
                </v-toolbar>
            </v-col>

            <loading-overlay :loading="loading"></loading-overlay>

            <div class="container">
                <v-stepper v-model="step" alt-labels>
                    <v-stepper-header
                        class="text-center"
                    >
                        <template v-for="n in steps">
                            <v-stepper-step
                                :key="`${n}-step`"
                                :complete="step > n"
                                :step="n"
                                editable
                            >
                            {{
                                n == 1
                                ? 'Financing Options'
                                : n == 2
                                ? 'Beneficiary Details'
                                : 'Payment' }}
                            </v-stepper-step>

                            <v-divider
                                v-if="n !== steps"
                                :key="n"
                            ></v-divider>
                        </template>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content
                            v-for="n in steps"
                            :key="`${n}-content`"
                            :step="n"
                        >
                            <v-row class="row-full mt-24" no-gutters>
                                <v-col>
                                    <financing
                                        v-if="n == 1"
                                    ></financing>

                                    <beneficiary v-else-if="n == 2"></beneficiary>

                                    <v-simple-table class="py-5" v-else>
                                        <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th class="text-left">Name</th>
                                                <th class="text-left">Price</th>
                                                <th class="text-left">Quantity</th>
                                                <th class="text-left">Total</th>
                                                <th class="text-center">Monthly Payments</th>
                                            </tr>
                                        </thead>

                                        <list :list="$store.state.autoloans"></list>
                                        </template>
                                    </v-simple-table>

                                    <v-btn
                                        color="primary"
                                        @click="nextStep(n)"
                                        v-if="n < 3"
                                    >
                                        Continue
                                    </v-btn>

                                    <div class="text-center" v-else>
                                        <v-btn
                                            color="primary"
                                            @click="payment"
                                        >
                                            Pay
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            <!-- <v-btn text>Cancel</v-btn> -->
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </v-container>
</template>

<script>
import beneficiary from './components/beneficiary';
import financing from './components/financing';
import list from './components/shopping-list'
import { categories } from '../../mixins/categories'

export default {
    components: { beneficiary, financing, list },
    data () {
        return {
            step: 1,
            steps: 3,
            loading: false,
        }
    },

    watch: {
        steps (val) {
            if (this.step > val) {
                this.step = val;
            }
        },
    },

    methods: {
        nextStep (n) {
            if (n === this.steps) {
                this.step = 1;
            } else {
                this.step = n + 1;
            }
        },
        payment() {
            this.loading = true;
            setTimeout(() => {
                this.$swal({
                    type: 'success',
                    text: 'Payment was successful!',
                });

                this.loading = false;
                this.$store.commit('removeLoans');
                this.$router.push('/autoloan');
            }, 3000);
        }
    },
}
</script>

<style scoped>
.v-stepper__label {
    text-align: center;
}

.go-back {
    position: absolute;
    left: 15px;
}
</style>
